//CSS Imports
//import '../sass/theme.scss';

//JS imports
// JavaScript Document
"use strict";

//se hace el import e integracion del jQuery cuando se carga desde webpack
// import $ from 'jquery';
// window.jQuery = $;
// window.$ = $;


(function($) {      
    jQuery(function ($) {
		console.log('Todo listo');
		require('./language_selector.js');
		require('./carousels.js');
		require('./tabs.js');
		require('./varios.js');
		require('./footer.js');
		
		if(jQuery('.layout-inner-section-js').length > 0  && jQuery('.layout-col-jacuzzi').length > 0){
			jQuery('.layout-col-jacuzzi').appendTo('.layout-inner-section-js .elementor-container');
		   
		  }
    });
  
})($);
